import { Option } from "@platform/design-system";
import { useMemo } from "react";

import { useRfpProductCoverages } from "../../../../hooks/useRfpProductCoverages";
import { ClientProductCarrierWithCarrier } from "../../../../types/rfpApi";

interface UseGetProductsResponse {
  products: Option[];
  productMap: Map<number, ClientProductCarrierWithCarrier>;
  isLoading?: boolean;
}

const useGetProducts = (
  rfpId: string | undefined,
): UseGetProductsResponse | undefined => {
  const { data: productCoverages, isLoading } = useRfpProductCoverages({
    rfpId,
  });

  const { productMap, products } = useMemo(() => {
    const productMap = new Map<number, ClientProductCarrierWithCarrier>();
    const products: Option[] = [];
    productCoverages?.forEach((product) => {
      productMap.set(product.id, product);
      const label = `${product.carrier.name} - ${product.groupNumber}`;
      products.push({ label, value: product.id });
    });
    return { productMap, products };
  }, [productCoverages]);

  return { productMap, products, isLoading };
};

export { useGetProducts };
